export default {
  zh: {
    moreStep: '还差一步！',
    verifyEmail: '完成绑定邮箱',
    enjoy: '获得',
    freeTrial: '3天免费试用期！',
    verifyBtn: '发送验证邮件',
    skipVerify: '跳过验证',
    checkAccount: '，前往个人中心'
  },
  en: {
    moreStep: 'Just one more step. ',
    verifyEmail: 'Verify your email ',
    enjoy: '  to get ',
    freeTrial: '3 days free trial!',
    verifyBtn: 'Send verification email',
    skipVerify: 'Skip verification',
    checkAccount: ' and check your account info'
  }
}



// WEBPACK FOOTER //
// ./src/views/verifyEmail/lang.js